import React, { FunctionComponent, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { ActionDocumentDropdownItem } from './ProgramDetail.models'
import { useOnMount } from '../../../utils/useOnMount'
import {
  StyledActionDropdown,
  StyledPatientActionLink,
  StyledPatientActionMenuWrapper
} from '../../Patients/PatientDashboard/PatientDashboard.styles'
import StatusTooltip from '../../Patients/PatientDashboard/StatusTooltip'
import { ClinTheme } from '../../../ClinTheme'
import { ClinSpinner } from '../../../components/ClinSpinner'

interface ITableActionMenuProps<T, I> {
  action: T
  items: I[]
  handleCloseActionMenu: () => void
}

const TableActionMenu: FunctionComponent<ITableActionMenuProps<any, any>> = ({
  items,
  action,
  handleCloseActionMenu
}) => {
  const { t } = useTranslation()
  const dropdownRef = useRef<any>()

  const handleOnClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    item: ActionDocumentDropdownItem
  ) => {
    if (!item.disabled) {
      item.onClick(action)
      event.stopPropagation()
    }
  }

  const handleOutusidePopupClick = (event: Event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      handleCloseActionMenu()
    }
  }

  useOnMount(() => {
    document.addEventListener('click', (event) =>
      handleOutusidePopupClick(event)
    )
  })

  return (
    <>
      <StyledActionDropdown
        onClick={(e) => e.stopPropagation()}
        ref={dropdownRef}
      >
        <StyledPatientActionMenuWrapper>
          {items &&
            items.length > 0 &&
            items.map((item: any, index) => {
              const linkContent = (
                <StyledPatientActionLink
                  variant="linkButton"
                  aria-disabled={item.disabled || item.isLoading}
                  tabIndex={item.disabled || item.isLoading ? -1 : 0}
                  onClick={(e) => {
                    if (!item.disabled && !item.isLoading) {
                      handleOnClick(e, item)
                    } else {
                      e.preventDefault()
                      e.stopPropagation()
                    }
                  }}
                  style={{
                    color:
                      item.disabled || item.isLoading
                        ? ClinTheme.colors.grey
                        : undefined,
                    cursor:
                      item.disabled || item.isLoading ? 'default' : 'pointer'
                  }}
                >
                  {item.isLoading && (
                    <div
                      style={{
                        display: 'inline-flex',
                        marginRight: '8px',
                        verticalAlign: 'sub'
                      }}
                    >
                      <ClinSpinner size={20} />
                    </div>
                  )}
                  {t(item.text)}
                </StyledPatientActionLink>
              )

              return item.disabled && item.tooltip ? (
                <StatusTooltip key={index} tooltipText={t(item.tooltip)}>
                  {linkContent}
                </StatusTooltip>
              ) : (
                <React.Fragment key={index}>{linkContent}</React.Fragment>
              )
            })}
        </StyledPatientActionMenuWrapper>
      </StyledActionDropdown>
    </>
  )
}

export default TableActionMenu
